<template>
  <div class="content-wrapper">
    <div class="left-content">
      <img class="book-cover" :src="book" :alt="alt" />
    </div>
    <div class="right-content">
      <p v-for="(p, i) in paragraphs" :key="i" class="paragraph">
        {{ p }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookContent",
  props: {
    book: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: "Book Cover",
    },
    paragraphs: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
/* TODO: remove padding on smaller screens */
.paragraph {
  font-size: 1em;
  color: black;
  margin: 0;
  padding-left: 1em;
  line-height: 1.6;
  padding-bottom: 0.5em;
  padding-top: 0em;
  font-family: PT Serif, serif;
}

.content-wrapper {
  display: flex;
  margin-bottom: 2em;
}

.left-content,
.right-content {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.book-cover {
  max-width: 100%;
  height: auto;
}

/* stack on small screens */
@media (max-width: 1024px) {
  .content-wrapper {
    flex-direction: column;
    align-items: center;
  }
}
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
    align-items: center;
  }
  .contentLeft,
  .contentRight {
    width: 100%;
  }
  .bookimage {
    max-width: 250px;
    margin-bottom: 1em;
  }
}
@media (max-width: 480px) {
  .paragraph {
    padding: 0.5em 1em;
  }
}
</style>
